
import Config from "../config";
import {PinModel,
        PinJSON,
        PinFactory,
        UserUIPreferenceModel,
        UserUIPreferenceFactory,
        UserProfileModel,
        UserProfileFactory,
        BarChartUIPreferenceModel} from '../models/modelsUserConfiguration';
import {BaseSuccessJSON,
        BaseSuccessModel,
        BaseSuccessFactory} from '../models/modelsException';

/*
import {formatDate} from "../utils/dateFunctions.js";
import {getIndustryFromVerticalBundle} from "../utils/mapFunctions.js";
*/

export const retrieveUserProfile = async(authToken: string): Promise<UserProfileModel> => {
    let url = `${Config.getInstance().getCoordinationServiceURL()}/api/me/r`;

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      })

      //nothing to be done in these cases
      if(response.status===401){
        throw new Error("Unhandled error in retrieveUserProfile")
      }
      if (!response.ok) {
        throw new Error("Unhandled error in retrieveUserProfile")
      }

      const data = await response.json();
      if(!data) {
        throw new Error("Unhandled error in retrieveUserProfile")
      }

      const thisProfile = new UserProfileFactory().fromJSON(data)
      return thisProfile
    } catch (error) {
      console.error(error);
      throw new Error(`Error when fetching user profile: ${(error as Error).message}`)
    }
  }

/*******************************/

export const retrieveUserPreference = async(authToken: string): Promise<UserUIPreferenceModel> => {
    let url = `${Config.getInstance().getCoordinationServiceURL()}/api/uconfig/r`;

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      })

      //nothing to be done in these cases
      if(response.status===401){
        throw new Error("Unhandled error")
      }
      if (!response.ok) {
        throw new Error("Unhandled error")
      }

      const data = await response.json();
      if(!data) {
        throw new Error("Unhandled error")
      }

      const thisPref = new UserUIPreferenceFactory().fromJSON(data)
      return thisPref
    } catch (error) {
      console.error(error);
      throw new Error(`Error when fetching UI Preference: ${(error as Error).message}`)
    }
  }

/*******************************/

export const upsertPin = async (authToken: string, objectApiName: string, recordUuid: string): Promise<PinModel> => {

    try {

      //set a pin for a specific object (e.g., pinning a ListView_mdt, or Application_mdt)
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/uconfig/pin/u/${objectApiName}/${recordUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.pin){
          throw new Error("Unhandled error")
      }

      const pin = new PinFactory().fromJSON(data.pin);

      return pin

    } catch (error){
      throw new Error(`Error when setting pin: ${(error as Error).message}`)
    }
}

export const deletePin = async (authToken: string, objectApiName: string, recordUuid: string): Promise<BaseSuccessModel> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/uconfig/pin/d/${objectApiName}/${recordUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.status || !data.message){
          throw new Error("Unhandled error")
      }

      const thisSuccess = new BaseSuccessFactory().fromJSON(data)

      return thisSuccess

    } catch (error){
      throw new Error(`Error when deleting pin: ${(error as Error).message}`)
    }
}
